import { memo } from "react";

import { FeatureIslandMain } from "@/components/features/_layouts";
import type * as FormModelType from "@/components/features/settings/payment-deposit-account/model/type";

import { MinimumTransferAmountForm, RemittanceAccountForm } from "./components";
import { usePaymentDepositAccountForm } from "./hooks";

type Props = {
	viewModel: FormModelType.PaymentDepositAccountFormModel["ViewModel"];
	onSetViewModel: (viewModel: FormModelType.PaymentDepositAccountFormModel["ViewModel"]) => void;
};

export const SettingsPaymentDepositAccountMain = memo(({ viewModel, onSetViewModel }: Props) => {
	const {
		onChangeMinimumTransferAmount,
		onChangeBankCode,
		onChangeBankBranchCode,
		onChangeBankAccountType,
		onChangeBankAccountNumber,
		onChangeBankAccountHolderName,
	} = usePaymentDepositAccountForm(viewModel, onSetViewModel);

	return (
		<FeatureIslandMain>
			<div>
				<p className="text-sm">
					チェックインベースで月2回ご指定の口座への入金となります。（15日締め月末払い、月末締め翌月15日払い）
					<br />
					尚、振込日が土日祝日の場合は、翌営業日の振込となります。
					<br />
					<strong className="text-brand">
						入金先情報は事前決済予約の入金先になります。登録がない場合事前決済が利用できませんので、必ず入力してください。
					</strong>
				</p>
			</div>

			<div className="mt-5 rounded-lg border border-zinc-100 bg-white p-4 lg:p-12">
				<MinimumTransferAmountForm
					minimumTransferAmount={viewModel.minimumTransferAmount.value}
					minimumTransferAmountErrorMessage={viewModel.minimumTransferAmount.error}
					onChangeMinimumTransferAmount={onChangeMinimumTransferAmount}
				/>

				<div className="border-b border-zinc-300" />

				<RemittanceAccountForm
					bankCode={viewModel.bankCode.value}
					bankCodeErrorMessage={viewModel.bankCode.error}
					bankBranchCode={viewModel.bankBranchCode.value}
					bankBranchCodeErrorMessage={viewModel.bankBranchCode.error}
					bankAccountType={viewModel.bankAccountType.value}
					bankAccountTypeErrorMessage={viewModel.bankAccountType.error}
					bankAccountNumber={viewModel.bankAccountNumber.value}
					bankAccountNumberErrorMessage={viewModel.bankAccountNumber.error}
					bankAccountHolderName={viewModel.bankAccountHolderName.value}
					bankAccountHolderNameErrorMessage={viewModel.bankAccountHolderName.error}
					onChangeBankCode={onChangeBankCode}
					onChangeBankBranchCode={onChangeBankBranchCode}
					onChangeBankAccountType={onChangeBankAccountType}
					onChangeBankAccountNumber={onChangeBankAccountNumber}
					onChangeBankAccountHolderName={onChangeBankAccountHolderName}
				/>
			</div>
		</FeatureIslandMain>
	);
});
